import React from 'react';

// Tone → light+dark classes. The only place status/badge colors are defined.
export const TONE_CLASSES = {
  gray: 'bg-gray-100 text-gray-700 dark:bg-slate-500/20 dark:text-slate-300',
  slate: 'bg-slate-200 text-slate-700 dark:bg-slate-500/20 dark:text-slate-300',
  blue: 'bg-blue-100 text-blue-800 dark:bg-blue-500/15 dark:text-blue-300',
  cyan: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-500/15 dark:text-cyan-300',
  teal: 'bg-teal-100 text-teal-800 dark:bg-teal-500/15 dark:text-teal-300',
  green: 'bg-green-100 text-green-800 dark:bg-green-500/15 dark:text-green-300',
  yellow: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-500/15 dark:text-yellow-300',
  amber: 'bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300',
  orange: 'bg-orange-100 text-orange-800 dark:bg-orange-500/15 dark:text-orange-300',
  red: 'bg-red-100 text-red-800 dark:bg-red-500/15 dark:text-red-300',
  pink: 'bg-pink-100 text-pink-800 dark:bg-pink-500/15 dark:text-pink-300',
  purple: 'bg-purple-100 text-purple-800 dark:bg-purple-500/15 dark:text-purple-300',
  indigo: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-500/15 dark:text-indigo-300',
  accent: 'bg-accent-soft text-accent-hover dark:text-accent',
};

// Accent-edge classes for tone-tinted containers (e.g. priority cards)
export const TONE_BORDER_CLASSES = {
  gray: 'border-gray-400 dark:border-slate-500',
  slate: 'border-slate-400 dark:border-slate-500',
  blue: 'border-blue-500 dark:border-blue-400',
  cyan: 'border-cyan-500 dark:border-cyan-400',
  teal: 'border-teal-500 dark:border-teal-400',
  green: 'border-green-500 dark:border-green-400',
  yellow: 'border-yellow-500 dark:border-yellow-400',
  amber: 'border-amber-500 dark:border-amber-400',
  orange: 'border-orange-500 dark:border-orange-400',
  red: 'border-red-500 dark:border-red-400',
  pink: 'border-pink-500 dark:border-pink-400',
  purple: 'border-purple-500 dark:border-purple-400',
  indigo: 'border-indigo-500 dark:border-indigo-400',
};

const SIZES = {
  sm: 'px-2 py-0.5 text-[11px] gap-1',
  md: 'px-2.5 py-1 text-xs gap-1.5',
  lg: 'px-3 py-1.5 text-sm gap-2',
};

export default function Badge({ tone = 'gray', size = 'md', icon: Icon, className = '', children, ...rest }) {
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full whitespace-nowrap ${TONE_CLASSES[tone] || TONE_CLASSES.gray} ${SIZES[size] || SIZES.md} ${className}`}
      {...rest}
    >
      {Icon && <Icon className="shrink-0" size={size === 'sm' ? 11 : size === 'lg' ? 14 : 12} />}
      {children}
    </span>
  );
}
